import { api } from "@/app/services/api.service";
import {
  extractAuditList,
  extractErrorMessage,
  unwrapPayload,
} from "./uraApi";

export { extractErrorMessage };

export const NIRA_CREDENTIALS_PATH = "configuration/integration/nira-credentials";
export const NIRA_CREDENTIALS_AUDIT_PATH = "configuration/integration/nira-credentials/audit";

export type NiraCredentials = {
  username: string | null;
  password: string | null;
  configured: boolean;
};

function readString(record: Record<string, unknown>, keys: string[]) {
  for (const key of keys) {
    const value = record[key];
    if (value != null && value !== "") return String(value);
  }
  return null;
}

export function parseNiraCredentials(body: unknown): NiraCredentials {
  if (body == null || typeof body !== "object") {
    return { username: null, password: null, configured: false };
  }
  const record = body as Record<string, unknown>;
  const username = readString(record, ["username"]);
  const password = readString(record, ["password"]);
  const configured = username != null && username.length > 0;

  return {
    username,
    password,
    configured,
  };
}

export async function fetchNiraCredentials(): Promise<NiraCredentials> {
  const res = await api().get(NIRA_CREDENTIALS_PATH);
  return parseNiraCredentials(unwrapPayload(res));
}

export async function saveNiraCredentials(payload: {
  username: string;
  password: string;
}) {
  await api().post(NIRA_CREDENTIALS_PATH, payload);
}

export async function fetchNiraCredentialsAudit(): Promise<Record<string, unknown>[]> {
  const res = await api().get(NIRA_CREDENTIALS_AUDIT_PATH);
  const root = res.data;
  if (Array.isArray(root)) return extractAuditList(root);
  if (root != null && typeof root === "object") {
    const rootObj = root as Record<string, unknown>;
    if (Array.isArray(rootObj.data)) return extractAuditList(rootObj.data);
    const fromUnwrapped = extractAuditList(unwrapPayload(res));
    if (fromUnwrapped.length > 0) return fromUnwrapped;
    return extractAuditList(root);
  }
  return [];
}
